/* Hannovae "Pair it" Essentials set module. Markup: snippets/hnv-pair-it.liquid */
(function () {
  if (window.customElements.get('hnv-pair-it')) return;
  var J = function (s, d) { try { return JSON.parse(s); } catch (e) { return d; } };
  var getJSON = function (url) { return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); }); };

  class HnvPairIt extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.ess = J(this.dataset.ess, []);
      this.mainId = Number(this.dataset.mainProduct);
      this.mainOptions = J(this.dataset.mainOptions, []);
      this.mainVariants = J(this.dataset.mainVariants, []);
      this.mainIds = J(this.dataset.mainIds, []);
      this.statusEl = this.querySelector('[data-hnv-status]');
      this.pickPercents();
      this.cards = Array.prototype.map.call(this.querySelectorAll('[data-hnv-card]'), this.setupCard.bind(this));
      this.syncFromMain(true);
      this.refresh();
      this.fitColumn();
      var self = this;
      var scope = this.closest('.shopify-section') || document;
      var later = function () { setTimeout(function () { self.syncFromMain(false); }, 80); };
      scope.addEventListener('change', later);
      scope.addEventListener('click', later);
      document.addEventListener('krown:cart:add', function () { setTimeout(function () { self.refresh(); }, 600); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden) self.refresh(); });
    }

    // The product info column is sticky. With this module it can be taller than the screen, which would hide
    // its lower part until the gallery ends. Anchor it by its bottom instead, so everything stays reachable.
    fitColumn() {
      var col = this.closest('.kt-product-information');
      if (!col || getComputedStyle(col).position !== 'sticky') return;
      var base = parseFloat(getComputedStyle(col).top) || 30;
      var apply = function () {
        if (window.innerWidth < 1024) { col.style.top = ''; return; }
        var h = col.offsetHeight, vh = window.innerHeight;
        col.style.top = (h + base * 2 > vh ? Math.round(vh - h - base) : base) + 'px';
      };
      apply();
      window.addEventListener('resize', apply);
      if (window.ResizeObserver) new ResizeObserver(apply).observe(col);
    }

    pickPercents() {
      var d = this.dataset, now = Date.now();
      var p2 = Number(d.p2) || 0, p3 = Number(d.p3) || 0, pp = Number(d.pp) || 0;
      var ps = Date.parse(d.ps), pe = Date.parse(d.pe);
      var promo = pp > 0 && ps && pe && now >= ps && now < pe;
      this.a2 = promo ? pp : p2;
      this.a3 = promo ? (p3 > pp ? p3 : 0) : p3;
      this.priceKey = promo ? 'np' : 'n2';
      var a2 = this.a2, a3 = this.a3;
      this.querySelectorAll('[data-hnv-pct2]').forEach(function (e) { e.textContent = a2; });
      this.querySelectorAll('[data-hnv-pct3]').forEach(function (e) { e.textContent = a3; });
      var t3 = this.querySelector('[data-hnv-t3]'); if (t3) t3.hidden = !a3;
      var s3 = this.querySelector('[data-hnv-step="3"]'); if (s3) s3.hidden = !a3;
      var two = this.querySelector('[data-hnv-two]'); if (two) two.textContent = a3 ? '2 pieces' : '2+ pieces';
      var lad = this.querySelector('.hnv-pair__ladder'); if (lad) lad.setAttribute('data-steps', a3 ? '3' : '2');
    }

    setupCard(el) {
      var card = {
        el: el,
        same: el.hasAttribute('data-same'),
        variants: J((el.querySelector('[data-hnv-variants]') || {}).textContent, []),
        opts: Array.prototype.slice.call(el.querySelectorAll('[data-hnv-opt]')),
        img: el.querySelector('[data-hnv-img]'),
        was: el.querySelector('[data-hnv-was]'),
        now: el.querySelector('[data-hnv-now]'),
        btn: el.querySelector('[data-hnv-add]'),
        label: el.querySelector('[data-hnv-label]'),
        variant: null
      };
      var self = this;
      card.opts.forEach(function (o) {
        if (o.tagName === 'SELECT') o.addEventListener('change', function () { o.setAttribute('data-touched', ''); self.updateCard(card); });
      });
      card.btn.addEventListener('click', function () { self.add(card); });
      this.updateCard(card);
      return card;
    }

    updateCard(card) {
      var vals = card.opts.map(function (o) { return o.value; });
      var v = card.variants.find(function (x) { return x.o.every(function (val, i) { return val === vals[i]; }); });
      card.variant = v || null;
      if (v) {
        if (card.img && v.i) card.img.src = v.i;
        if (card.was) card.was.textContent = v.w;
        if (card.now) card.now.textContent = v[this.priceKey] || v.n2;
      }
      card.btn.disabled = !(v && v.a);
      if (!v || !v.a) card.label.textContent = 'Sold out';
      else this.setLabel(card);
    }

    setLabel(card) {
      if (!card.variant || !card.variant.a) return;
      card.label.textContent = this.mainInCart ? 'Add' : 'Add both';
    }

    mainVariantId() {
      var form = document.getElementById(this.dataset.mainForm);
      var input = form && form.querySelector('input[name="id"]');
      var id = input ? Number(input.value) : 0;
      return this.mainIds.indexOf(id) > -1 ? id : 0;
    }

    mainSelectedOptions() {
      var id = this.mainVariantId();
      var i = this.mainIds.indexOf(id);
      return i > -1 ? this.mainVariants[i] : null;
    }

    syncFromMain(first) {
      var sel = this.mainSelectedOptions();
      if (!sel) return;
      var key = sel.join('|');
      if (!first && key === this._lastMain) return;
      this._lastMain = key;
      var names = this.mainOptions.map(function (n) { return String(n).toLowerCase(); });
      var sizeIdx = names.findIndex(function (n) { return /size|taille|größe/.test(n); });
      var colourIdx = names.findIndex(function (n) { return /colou?r|couleur|farbe/.test(n); });
      var self = this;
      this.cards.forEach(function (card) {
        var changed = false;
        card.opts.forEach(function (o) {
          if (o.tagName !== 'SELECT' || o.hasAttribute('data-touched')) return;
          var nm = String(o.getAttribute('data-hnv-opt-name') || '').toLowerCase();
          var has = function (val) { return Array.prototype.some.call(o.options, function (op) { return op.value === val; }); };
          if (sizeIdx > -1 && /size|taille|größe/.test(nm) && has(sel[sizeIdx]) && o.value !== sel[sizeIdx]) { o.value = sel[sizeIdx]; changed = true; }
          if (card.same && colourIdx > -1 && /colou?r|couleur|farbe/.test(nm) && o.value === sel[colourIdx]) {
            var other = Array.prototype.find.call(o.options, function (op) { return op.value !== sel[colourIdx]; });
            if (other) { o.value = other.value; changed = true; }
          }
        });
        if (changed || first) self.updateCard(card);
      });
    }

    refresh() {
      var self = this;
      return getJSON(this.dataset.cart + '.js').then(function (cart) {
        self.cart = cart;
        self.render();
      }).catch(function () {});
    }

    render() {
      var ess = this.ess, mainId = this.mainId;
      var items = (this.cart && this.cart.items) || [];
      var n = items.filter(function (i) { return ess.indexOf(i.product_id) > -1; }).reduce(function (s, i) { return s + i.quantity; }, 0);
      this.mainInCart = items.some(function (i) { return i.product_id === mainId; });
      var a2 = this.a2, a3 = this.a3, reached = 0;
      if (n >= 3 && a3) reached = 3; else if (n >= 2) reached = 2; else if (n >= 1) reached = 1;
      var next = reached < 2 ? 2 : (a3 && reached === 2 ? 3 : 0);
      this.querySelectorAll('[data-hnv-step]').forEach(function (s) {
        var k = Number(s.getAttribute('data-hnv-step'));
        s.classList.toggle('is-on', k === reached);
        s.classList.toggle('is-next', k === next && !s.hidden);
      });
      var msg;
      if (n === 0) msg = 'Add this with any other Essential and both are <strong>' + a2 + '% off</strong>.';
      else if (n === 1) msg = 'One Essential in your bag. Add another and both are <strong>' + a2 + '% off</strong>.';
      else if (a3 && n === 2) msg = '<strong>' + a2 + '% off</strong> is on. Add a third piece for ' + a3 + '% off.';
      else msg = '<strong>' + (a3 && n >= 3 ? a3 : a2) + '% off</strong> is on for your Essentials.';
      if (this.statusEl) this.statusEl.innerHTML = msg;
      var self = this;
      this.cards.forEach(function (c) { self.setLabel(c); });
    }

    add(card) {
      if (this.busy || !card.variant || !card.variant.a) return;
      this.busy = true;
      var self = this, btn = card.btn;
      btn.classList.add('is-busy');
      getJSON(this.dataset.cart + '.js').catch(function () { return { items: [] }; }).then(function (cart) {
        var mainId = self.mainId;
        var mainInCart = (cart.items || []).some(function (i) { return i.product_id === mainId; });
        var items = [];
        if (!mainInCart) {
          var mv = self.mainVariantId();
          if (!mv) throw new Error('Pick your size above first.');
          items.push({ id: mv, quantity: 1 });
        }
        items.push({ id: card.variant.id, quantity: 1 });
        return fetch(self.dataset.cartAdd + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'That did not go into your bag. Try again.'); return j; });
        });
      }).then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        card.label.textContent = 'Added';
        setTimeout(function () { btn.classList.remove('is-done'); self.setLabel(card); }, 2200);
        return self.openDrawer();
      }).then(function () { return self.refresh(); }).catch(function (e) {
        btn.classList.remove('is-busy');
        if (self.statusEl) self.statusEl.textContent = (e && e.message) || 'That did not go into your bag. Try again.';
      }).then(function () { self.busy = false; });
    }

    openDrawer() {
      var cartUrl = this.dataset.cart;
      return fetch('?section_id=helper-cart', { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var f = document.getElementById('AjaxCartForm'), nf = doc.getElementById('AjaxCartForm');
        if (f && nf) { f.innerHTML = nf.innerHTML; if (typeof f.ajaxifyCartItems === 'function') f.ajaxifyCartItems(); }
        var s = document.getElementById('AjaxCartSubtotal'), ns = doc.getElementById('AjaxCartSubtotal');
        if (s && ns) s.innerHTML = ns.innerHTML;
        var cc = doc.querySelector('[data-cart-count]'), ct = doc.querySelector('[data-cart-total]');
        if (cc) document.querySelectorAll('[data-header-cart-count]').forEach(function (e) { e.textContent = cc.textContent; });
        if (ct) document.querySelectorAll('[data-header-cart-total]').forEach(function (e) { e.textContent = ct.textContent; });
        var sb = document.getElementById('site-cart-sidebar');
        if (sb && typeof sb.show === 'function') {
          sb.show();
          if (window.KROWN && KROWN.functions && typeof KROWN.functions.eventDispatcher === 'function') KROWN.functions.eventDispatcher('krown:cart-sidebar:show', { sidebarElement: sb });
          var rec = document.getElementById('cart-recommendations-sidebar');
          if (rec && typeof rec.generateRecommendations === 'function') rec.generateRecommendations();
        } else {
          window.location.href = cartUrl;
        }
      }).catch(function () { window.location.href = cartUrl; });
    }
  }
  window.customElements.define('hnv-pair-it', HnvPairIt);
})();